import React from "react";
import Render from "@gqlapp/theme";
import header from "../templates/header.html.twig";

export default function HeaderBlock(){
	return <Render template={header} context={{}} />;
}
